import React, {useState, useEffect, useMemo} from 'react';
import _, {debounce} from 'lodash';
import {Card, Form, Input, DatePicker, Cascader, Button, message, Image, InputNumber} from 'antd';
import SPUploadSinglePhoto from 'components/base/SPUploadSinglePhoto'
import SPUploadSingleFile from 'components/base/SPUploadSingleFile'
import {useServicePolicyTemplate} from "../../../hooks/product-price/service-policy-template";
import SPSelectWithEnum from 'components/base/SPSelectWithEnum'
import SPSelectWithApi from 'components/base/SPSelectWithApi'
import { DownloadOutlined } from '@ant-design/icons';
import { useSupplierEntry } from '../../../hooks/supplier-entry';
import {_APIS} from "../../../apis";
import SPAggregate from "../../base/SPAggregate";
import SPDatePickerString from "components/base/SPDatePickerString";
import {API_UPLOAD_QUALIFICATION, API_VEHICLE_UPLOAD_PHOTO_BY_TYPE} from "../../../hooks/carRental/_";
import moment from "moment/moment";
import {deepCopy} from "../../../utils/tool";
import {encryptTextByAES, decryptTextByAES} from "utils/encryption";
const defaultBankQueryStr = '行'

const ID_CARD_URL = `${
  (window as any).GLOBAL_CARRENTAL_API_PREFIX
}/ota/rental/scm/file/upload?tag=id-card`
const COMMON_URL = `${
  (window as any).GLOBAL_CARRENTAL_API_PREFIX
}/ota/rental/scm/file/upload?tag=common`


const { RangePicker } = DatePicker;
const { TextArea } = Input;

const urlMap = {

}


interface props {
  enums?: any
  supplierInfo?: any
  nextStep?: any
  refresh?: any
}

const enCodeList = [
  ['legal_person_cfg', 'legal_person_identity_code_encrypt'],
  ['beneficiary_cfg', 'beneficiary_identity_code_encrypt'],
  ['legal_person_agent_cfg', 'legal_person_agent_identity_no_encrypt'],
  ['legal_person_agent_cfg', 'legal_person_agent_cell_phone_encrypt'],
]

const imgKeyList = [
  ['merchant_basic_cfg', 'business_license_url'],
  ['legal_person_cfg', 'legal_person_identity_url_front'],
  ['legal_person_cfg', 'legal_person_identity_url_back'],
  ['beneficiary_cfg', 'beneficiary_identity_url_back'],
  ['beneficiary_cfg', 'beneficiary_identity_url_front'],
  ['legal_person_agent_cfg', 'legal_person_agent_identity_url_back'],
  ['legal_person_agent_cfg', 'legal_person_agent_identity_url_front'],
  ['intent_letter_cfg', 'intent_letter_url'],
  ['intent_letter_cfg', 'intent_letter_sign_person_url'],
]


const startTimeKeyList = [
  ['merchant_basic_cfg', 'business_start_time'],
  ['legal_person_cfg', 'legal_person_identity_start_time'],
  ['beneficiary_cfg', 'beneficiary_identity_start_time'],
  ['legal_person_agent_cfg', 'legal_person_agent_identity_start_time']
]
const endTimeKeyList = [
  ['merchant_basic_cfg', 'business_expire_time'],
  ['beneficiary_cfg', 'beneficiary_identity_expire_time'],
  ['legal_person_cfg', 'legal_person_identity_expire_time'],
  ['legal_person_agent_cfg', 'legal_person_agent_identity_expire_time']
]

const SPApplySettlementAccount: React.FC<props> = (props) => {
  const [cityList, setCityList] = useState([])
  const [cityListOrigin, setCityListOrigin] = useState([])
  const [bankList, setBankList] = useState([])
  const [bankCode, setBankCode] = useState(null)
  const [branchBankList, setBranchBankList] = useState([])
  const [mainForm] = Form.useForm();
  const [formValue, setFormValue] = useState<any>()

  const { enums, supplierInfo, nextStep, refresh } = props
  const { getMinCityList, getBankList, getBankChannelList, basicSave, merchantSettle, getCityList } = useSupplierEntry();

  useEffect(() => {
    getCityList().then((res) => {
      setCityListOrigin(res.data)
    })
    getMinCityList({ queryType: 5 }).then((res) => {
      setCityList(res.data)
    })
    getBankList({
      bank_name: defaultBankQueryStr
    }).then((res) => {
      setBankList(res.data)
    })
  }, []);

  // 其实这是初始化的逻辑
  useEffect(() => {
    if (supplierInfo) {
      setBankCode(supplierInfo?.merchant_bank_cfg?.bank || '')
      const copySupplierInfo = _.cloneDeep(supplierInfo)
      initProcessData(copySupplierInfo) // 原数据的处理逻辑
      mainForm.setFieldsValue(copySupplierInfo) // copy一份，设置表单
      setFormValue(_.cloneDeep(copySupplierInfo)) // copy一份，维护属性
    }
  }, [supplierInfo]);

  const downLoadTemplate = () => {
    const link = document.createElement('a');
    link.href = 'https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/开户意愿书模版.docx'; // 替换为实际的模版文件路径
    link.download = '开户意愿书模版.docx'; // 替换为文件名和扩展名
    link.click();
  }

  const initProcessData = (formData: any) => {
    formData.merchant_bank_cfg.province_id = Number(formData.merchant_bank_cfg.province_id) || null
    formData.merchant_bank_cfg.city_id = Number(formData.merchant_bank_cfg.city_id) || null
    formData.merchant_basic_cfg.merchant_register_province_id = Number(formData.merchant_basic_cfg.merchant_register_province_id) || null
    formData.merchant_basic_cfg.merchant_register_city_id = Number(formData.merchant_basic_cfg.merchant_register_city_id) || null
    // 初始化改数据就行，因为会统一setvalue
    if (formData.legal_person_cfg) {
      formData.legal_person_cfg.legal_person_name = formData?.merchant_basic_cfg?.legal_person_name
    }
    if (formData?.merchant_basic_cfg) {
      formData.merchant_basic_cfg.supplier_name = formData.supplier_name
      formData.merchant_basic_cfg.supplier_simple_name = formData.supplier_simple_name
      formData.merchant_bank_cfg.name = formData.supplier_name
    }
    enCodeList.forEach(key => {
      if (formData[key[0]] && formData[key[0]][key[1]] ) {
        formData[key[0]][key[1]] = decryptTextByAES(formData[key[0]][key[1]])
      }
    })
    imgKeyList.forEach(key => {
      if (formData[key[0]] && formData[key[0]][key[1]] ) {
        formData[key[0]][key[1]] = formData[key[0]][key[1] + '_temp']
      }
    })
  }

  useEffect(() => {
    // 这一块想表单数据联动，需要setValue,只改数据没用
    if (formValue?.legal_person_cfg) {
      mainForm.setFieldsValue({
        legal_person_cfg: {
          legal_person_name: formValue?.merchant_basic_cfg?.legal_person_name,
        }
      })
    }
    if (formValue?.beneficiary_cfg?.beneficiary_type === 0) {
      mainForm.setFieldsValue({
        beneficiary_cfg: {
          beneficiary_identity_expire_time: formValue?.legal_person_cfg?.legal_person_identity_expire_time,
          beneficiary_identity_start_time: formValue?.legal_person_cfg?.legal_person_identity_start_time,
          beneficiary_identity_url_front: formValue?.legal_person_cfg?.legal_person_identity_url_front,
          beneficiary_identity_url_back: formValue?.legal_person_cfg?.legal_person_identity_url_back,
          beneficiary_identity_code_encrypt: formValue?.legal_person_cfg?.legal_person_identity_code_encrypt,
          beneficiary_name: formValue?.legal_person_cfg.legal_person_name
        }
      })
    }
    if (formValue?.legal_person_agent_cfg?.legal_person_agent_type === 0) {
      mainForm.setFieldsValue({
        legal_person_agent_cfg: {
          legal_person_agent_identity_start_time: formValue?.legal_person_cfg?.legal_person_identity_start_time,
          legal_person_agent_identity_expire_time: formValue?.legal_person_cfg?.legal_person_identity_expire_time,
          legal_person_agent_identity_url_front: formValue?.legal_person_cfg?.legal_person_identity_url_front,
          legal_person_agent_identity_url_back: formValue?.legal_person_cfg?.legal_person_identity_url_back,
          legal_person_agent_identity_no_encrypt: formValue?.legal_person_cfg?.legal_person_identity_code_encrypt,
          legal_person_agent_name: formValue?.legal_person_cfg.legal_person_name
        }
      })
    }

  }, [formValue]);



  const submitProcessData = (formData: any) => {
    formData.merchant_bank_cfg.province_id = String(formData.merchant_bank_cfg.province_id || '')
    formData.merchant_bank_cfg.city_id = String(formData.merchant_bank_cfg.city_id || '')
    formData.merchant_basic_cfg.merchant_register_province_id = String(formData.merchant_basic_cfg.merchant_register_province_id || '')
    formData.merchant_basic_cfg.merchant_register_city_id = String(formData.merchant_basic_cfg.merchant_register_city_id || '')
    imgKeyList.forEach(key => {
      if (formData[key[0]] && formData[key[0]][key[1]]) {
        if (typeof formData[key[0]][key[1]] === 'object') {
          formData[key[0]][key[1]] = formData[key[0]][key[1]].file_addr
        } else {
          formData[key[0]][key[1]] = supplierInfo[key[0]][key[1]]
          if (formData?.beneficiary_cfg?.beneficiary_type === 0) {
           if (key[1] === 'beneficiary_identity_url_back') {
             formData[key[0]][key[1]] = supplierInfo['legal_person_cfg']['legal_person_identity_url_back']
           } else if (key[1] === 'beneficiary_identity_url_front') {
             formData[key[0]][key[1]] =  supplierInfo['legal_person_cfg']['legal_person_identity_url_front']
           }
          }
          if (formData?.legal_person_agent_cfg?.legal_person_agent_type === 0) {
            if (key[1] === 'legal_person_agent_identity_url_back') {
              formData[key[0]][key[1]] =  supplierInfo['legal_person_cfg']['legal_person_identity_url_back']
            } else if (key[1] === 'legal_person_agent_identity_url_front') {
              formData[key[0]][key[1]] =  supplierInfo['legal_person_cfg']['legal_person_identity_url_front']
            }
          }
        }
      }
    })
    enCodeList.forEach(key => {
      if (formData[key[0]] && formData[key[0]][key[1]] ) {
        formData[key[0]][key[1]] = encryptTextByAES(formData[key[0]][key[1]])
      }
    })
    startTimeKeyList.forEach(key => {
      if (formData[key[0]] && formData[key[0]][key[1]] ) {
        formData[key[0]][key[1]] = formData[key[0]][key[1]] ? (formData[key[0]][key[1]]?.length > 10 ? formData[key[0]][key[1]] : `${formData[key[0]][key[1]]} 00:00:00`) :  formData[key[0]][key[1]];
      }
    })
    endTimeKeyList.forEach(key => {
      if (formData[key[0]] && formData[key[0]][key[1]] ) {
        formData[key[0]][key[1]] = formData[key[0]][key[1]] ? (formData[key[0]][key[1]]?.length > 10 ? formData[key[0]][key[1]] : `${formData[key[0]][key[1]]} 23:59:59`) :  formData[key[0]][key[1]];
      }
    })
    return formData
  }
  const onSave = debounce(() => {
    const formData = mainForm.getFieldsValue();
    const data = deepCopy(formData)
    data.merchant_bank_cfg.bank = bankCode
    return basicSave(submitProcessData(data)).then((res: any) => {
      if (res.errno === 0) {
        message.success('保存成功');
      }
    })
  }, 2000, {
    leading: true, // 在调用时立即执行函数
    trailing: false // 防止在等待时间后再次执行函数
  });
  const onSubmit = debounce(() => {
    mainForm.validateFields().then(async (values: any) => {
      try {
        await onSave()
        const res: any = await merchantSettle()
        if (res.errno === 0) {
          message.success('提交成功');
          refresh()
        }
      } catch (e) {
        message.error('提交失败');
      }
    }).catch((err) => {
      console.log(err);
      mainForm.scrollToField(err?.errorFields?.[0]?.name)
    });
  }, 2000, {
    leading: true, // 在调用时立即执行函数
    trailing: false // 防止在等待时间后再次执行函数
  });

  const changeBusinessLicense = (data: any) => {

    mainForm.setFieldsValue({
      merchant_basic_cfg: {
        "social_credit_code": '',
        "legal_person_name": '',
        "business_start_time": '',
        "business_expire_time": '',
        "merchant_register_biz": '',
        "merchant_register_address": '',
        "register_capital": '',
      }
    });
    if (data && !data?.ocr_result && data.file_addr) {
      message.error('OCR识别失败，可重新上传图片');
      return;
    }
    if (data && data?.ocr_result?.file_type === 4 && data?.ocr_result?.business_license) {
      const result = data?.ocr_result?.business_license || {};
      mainForm.setFieldsValue({
        merchant_basic_cfg: {
          ...result,
          business_start_time: moment(result.business_start_time).isValid() ? result.business_start_time : '',
          business_expire_time: moment(result.business_expire_time).isValid() ? result.business_expire_time : '',
        }
      });
    }
  };

  const onBankChange = async (data: any) => {
    const item: any = bankList.find((item: any) => item.bankName === data)
    setBankCode(item.bankCode)
  }

  const onValuesChange = (changedValues: any, allValues: any) => {
    setFormValue(JSON.parse(JSON.stringify(allValues)));
    if (changedValues?.beneficiary_cfg?.beneficiary_type === 1) {
      mainForm && mainForm.setFieldsValue({
        beneficiary_cfg: {
          beneficiary_identity_expire_time: '',
          beneficiary_identity_start_time: '',
          beneficiary_identity_url_front: '',
          beneficiary_identity_url_back: '',
          beneficiary_identity_code_encrypt: '',
          beneficiary_name: ''
        }
      })
    }
    if (changedValues?.legal_person_agent_cfg?.legal_person_agent_type === 1) {
      mainForm.setFieldsValue({
        legal_person_agent_cfg: {
          legal_person_agent_identity_start_time: '',
          legal_person_agent_identity_expire_time: '',
          legal_person_agent_identity_url_front: '',
          legal_person_agent_identity_url_back: '',
          legal_person_agent_identity_no_encrypt: '',
          legal_person_agent_name: ''
        }
      })
    }
  };
  const displayRender = (labels: any) => labels.join('  ');

  const formDisabled = useMemo(() => {
    return ![0, 2].includes(supplierInfo?.entering_status)
  }, [supplierInfo?.entering_status] )

  const beneficiaryIsLegal = useMemo(() => {
    return formValue?.beneficiary_cfg?.beneficiary_type === 0
  }, [formValue?.beneficiary_cfg?.beneficiary_type] )

  const legalAgentIsLegal = useMemo(() => {
    return formValue?.legal_person_agent_cfg?.legal_person_agent_type === 0
  }, [formValue?.legal_person_agent_cfg?.legal_person_agent_type] )





  return (

    <Form disabled={formDisabled} onValuesChange={onValuesChange} labelCol={{style: {width: '180px'}}} form={mainForm}>
      <Card title='营业执照信息' >
        <div style={{width:'50%', margin: '0 auto' }}>
          <Form.Item
            label="营业执照照片"
            extra={(<div style={{color: '#ff4d4f'}}>请上传手机自带相机拍的原件照或加盖公章的扫描件</div>)}
            name={['merchant_basic_cfg', 'business_license_url']}
            rules={[{required: true, message: '请上传'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                name={['merchant_basic_cfg', 'business_license_url']}
                noStyle
              >
                <SPUploadSinglePhoto
                  fileSize={10}
                  onChange={changeBusinessLicense}
                  action={`${
                    (window as any).GLOBAL_CARRENTAL_API_PREFIX
                  }/ota/rental/scm/file/uploadByType?tag=qualification&file_type=4`}
                   hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{position: 'relative'}}>
                <SPUploadSinglePhoto isDisabled
                                     value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shiliyingyezhizhao.png'
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="企业名称"
            name={['merchant_basic_cfg', 'supplier_name']}
            rules={[{required: true, message: '请输入'}]}
          >
            <Input disabled placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="企业简称"
            name={['merchant_basic_cfg', 'supplier_simple_name']}
            rules={[{required: true, message: '请输入'}]}
          >
            <Input disabled placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="统一社会信用代码"
            name={['merchant_basic_cfg', 'social_credit_code']}
            rules={[
              {required: true, message: '请输入'},
              { pattern: /^[\w\d]+$/, message: '请输入字母、数字'},
            ]}
          >
            <Input maxLength={50} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="营业开始日期"
            name={['merchant_basic_cfg', 'business_start_time']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPDatePickerString  placeholder='请选择' format="YYYY-MM-DD"   />
          </Form.Item>
          <Form.Item
            label="营业截止日期"
            name={['merchant_basic_cfg', 'business_expire_time']}
            rules={[{required: true, message: '请选择'}]}
          >
            <Form.Item
              noStyle={true}
              name={['merchant_basic_cfg', 'business_expire_time']}
            >
              <SPDatePickerString  placeholder='请选择' allowPermanent={true} format="YYYY-MM-DD"  />
            </Form.Item>
          </Form.Item>
          <Form.Item
            label="法定代表人"
            name={['merchant_basic_cfg', 'legal_person_name']}
            rules={[
              {required: true, message: '请输入'},
              { pattern: /^[\w\d\u4e00-\u9fa5]+$/, message: '请输入中文、数字、字母'},
            ]}
          >
            <Input maxLength={50} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="注册资本"
            name={['merchant_basic_cfg', 'register_capital']}
            rules={[
              {required: true, message: '请输入'},
              { pattern: /^[0]*[1-9]\d*(\.\d{1,2})?$|^[0]*\d\.\d{1,2}$/, message: '请输入数字，最多两位小数'},
            ]}
          >
            <Input maxLength={20} placeholder='请输入' addonAfter='万元'></Input>
          </Form.Item>
          <Form.Item
            label="经营范围"
            name={['merchant_basic_cfg', 'merchant_register_biz']}
            rules={[
              {required: true, message: '请输入'},
              // { pattern: /^[\w\d\u4e00-\u9fa5]+$/, message: '请输入中文、数字、字母'},
            ]}
          >
            <TextArea maxLength={800} placeholder='请输入'></TextArea>
          </Form.Item>

          <Form.Item
            label="注册省市"
            name={['merchant_basic_cfg', 'merchant_register_city_id']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPAggregate noStyle names={[['merchant_basic_cfg', 'merchant_register_province_id'], ['merchant_basic_cfg', 'merchant_register_city_id']]}>
              <Cascader
                displayRender={displayRender}
                multiple={false}
                placeholder='请选择'
                fieldNames={{ label: 'name', value: 'didi_id', children: 'child' }}
                style={{ width: '100%' }}
                options={cityListOrigin}
              />
            </SPAggregate>
          </Form.Item>
          <Form.Item
            label="注册详细地址"
            name={['merchant_basic_cfg', 'merchant_register_address']}
            rules={[
              {required: true, message: '请输入'},
              // { pattern: /^[\w\d\u4e00-\u9fa5]+$/, message: '请输入中文、数字、字母'},
            ]}
          >
            <Input maxLength={100} placeholder='请输入'></Input>
          </Form.Item>

          <Form.Item
            label="商户类型"
            name={['merchant_basic_cfg', 'merchant_type']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPSelectWithEnum
              placeholder='请选择'
              enums={enums}
              enumKey={'merchant_type'}>
            </SPSelectWithEnum>
          </Form.Item>
        </div>
      </Card>
      <Card title='法人身份证信息'>
        <div style={{width: '50%', margin: '0 auto'}}>
          <Form.Item
            label="法人身份证人像面"
            name={['legal_person_cfg', 'legal_person_identity_url_front']}
            rules={[{required: true, message: '上传图片'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                noStyle
                name={['legal_person_cfg', 'legal_person_identity_url_front']}
              >
                <SPUploadSinglePhoto  fileSize={10} action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{ position: 'relative' }}>
                <SPUploadSinglePhoto isDisabled value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shilirenxiang.png' action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{ bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="法人身份证国徽面"
            name={['legal_person_cfg', 'legal_person_identity_url_back']}
            rules={[{required: true, message: '上传图片'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                noStyle
                name={['legal_person_cfg', 'legal_person_identity_url_back']}
              >
                <SPUploadSinglePhoto  fileSize={10} action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{position: 'relative'}}>
                <SPUploadSinglePhoto isDisabled
                                     value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shiliguohui.png'
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="法人姓名"
            name={['legal_person_cfg', 'legal_person_name']}
            rules={[
              {required: true, message: '请输入'},
              { pattern: /^[\w\d\u4e00-\u9fa5]+$/, message: '请输入中文、数字、字母'},
            ]}
          >
            <Input disabled maxLength={50} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="法人身份证号"
            name={['legal_person_cfg', 'legal_person_identity_code_encrypt']}
            rules={[{ required: true, message: '请输入正确身份证号',pattern: /^\d+(\d|X)$/}]}
          >
            <Input maxLength={18} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="证件开始时间"
            name={['legal_person_cfg', 'legal_person_identity_start_time']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPDatePickerString  placeholder='请选择' format="YYYY-MM-DD"   />
          </Form.Item>
          <Form.Item
            label="证件结束时间"
            name={['legal_person_cfg', 'legal_person_identity_expire_time']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPDatePickerString  placeholder='请选择' allowPermanent={true} format="YYYY-MM-DD"  />
          </Form.Item>
          {/*<Form.Item*/}
          {/*  label="法人手机号"*/}
          {/*  name={['legal_person_cfg', 'aa']}*/}
          {/*  extra='该手机号将用于结算账户合作协议使用'*/}
          {/*>*/}
          {/*  <Input placeholder='请输入'></Input>*/}
          {/*</Form.Item>*/}
          <Form.Item
            label="受益人类型"
            name={['beneficiary_cfg', 'beneficiary_type']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPSelectWithEnum
              placeholder='请选择'
              enums={enums}
              enumKey={'beneficiary_type'}>
            </SPSelectWithEnum>
          </Form.Item>
        </div>
      </Card>
      <Card title='受益人信息' style={{ display: beneficiaryIsLegal ? 'none' : 'block' }}>
        <div style={{width: '50%', margin: '0 auto'}}>
          <Form.Item
            label="受益人身份证人像面"
            name={['beneficiary_cfg', 'beneficiary_identity_url_front']}
            rules={[{required: true, message: '上传图片'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                name={['beneficiary_cfg', 'beneficiary_identity_url_front']}
                noStyle
              >
                <SPUploadSinglePhoto
                  fileSize={10}
                  isDisabled={beneficiaryIsLegal || formDisabled}
                  action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{position: 'relative'}}>
                <SPUploadSinglePhoto isDisabled
                                     value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shilirenxiang.png'
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="受益人身份证国徽面"
            name={['beneficiary_cfg', 'beneficiary_identity_url_back']}
            rules={[{required: true, message: '上传图片'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                name={['beneficiary_cfg', 'beneficiary_identity_url_back']}
                noStyle
              >
                <SPUploadSinglePhoto
                  fileSize={10}
                  isDisabled={beneficiaryIsLegal || formDisabled}
                  action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{position: 'relative'}}>
                <SPUploadSinglePhoto isDisabled
                                     value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shiliguohui.png'
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="受益人姓名"
            name={['beneficiary_cfg', 'beneficiary_name']}
            rules={[
              {required: true, message: '请输入'},
              { pattern: /^[\w\d\u4e00-\u9fa5]+$/, message: '请输入中文、数字、字母'},
            ]}
          >
            <Input disabled={beneficiaryIsLegal || formDisabled} maxLength={50} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="受益人身份证号"
            name={['beneficiary_cfg', 'beneficiary_identity_code_encrypt']}
            rules={[{ required: true, message: '请输入正确身份证号',pattern: /^\d+(\d|X)$/}]}
          >
            <Input
              disabled={beneficiaryIsLegal || formDisabled}
              maxLength={18} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="证件开始时间"
            name={['beneficiary_cfg', 'beneficiary_identity_start_time']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPDatePickerString
              disabled={beneficiaryIsLegal || formDisabled}
              placeholder='请选择' format="YYYY-MM-DD"   />
          </Form.Item>
          <Form.Item
            label="证件结束时间"
            name={['beneficiary_cfg', 'beneficiary_identity_expire_time']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPDatePickerString
              disabled={beneficiaryIsLegal || formDisabled}
              placeholder='请选择' allowPermanent={true} format="YYYY-MM-DD"  />
          </Form.Item>
        </div>
      </Card>

      <Card title='签约人信息'>
        <div style={{width: '50%', margin: '0 auto'}}>
          <Form.Item
            label="签约人类型"
            name={['legal_person_agent_cfg', 'legal_person_agent_type']}
            rules={[
              {required: true, message: '请选择'},
              { pattern: /^[\w\d\u4e00-\u9fa5]+$/, message: '请输入中文、数字、字母'},
            ]}
          >
            <SPSelectWithEnum
              placeholder='请选择'
              enums={enums}
              enumKey={'legal_person_agent_type'}>
            </SPSelectWithEnum>
          </Form.Item>

          <Form.Item
            label="签约人身份证人像面"
            name={['legal_person_agent_cfg', 'legal_person_agent_identity_url_front']}
            rules={[{required: true, message: '上传图片'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                name={['legal_person_agent_cfg', 'legal_person_agent_identity_url_front']}
                noStyle
              >
                <SPUploadSinglePhoto  fileSize={10} isDisabled={legalAgentIsLegal || formDisabled}
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{position: 'relative'}}>
                <SPUploadSinglePhoto isDisabled
                                     value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shilirenxiang.png'
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>
          <Form.Item
            label="签约人身份证国徽面"
            name={['legal_person_agent_cfg', 'legal_person_agent_identity_url_back']}
            rules={[{required: true, message: '上传图片'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                name={['legal_person_agent_cfg', 'legal_person_agent_identity_url_back']}
                noStyle
              >
                <SPUploadSinglePhoto
                  fileSize={10}
                  isDisabled={legalAgentIsLegal || formDisabled}
                  action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{position: 'relative'}}>
                <SPUploadSinglePhoto isDisabled
                                     value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shiliguohui.png'
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>

          <Form.Item
            label="签约人姓名"
            name={['legal_person_agent_cfg', 'legal_person_agent_name']}
            rules={[
              {required: true, message: '请输入'},
              { pattern: /^[\w\d\u4e00-\u9fa5]+$/, message: '请输入中文、数字、字母'},
            ]}
          >
            <Input
              disabled={legalAgentIsLegal || formDisabled}
              maxLength={50} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="签约人身份证号"
            name={['legal_person_agent_cfg', 'legal_person_agent_identity_no_encrypt']}
            rules={[{ required: true, message: '请输入正确身份证号',pattern: /^\d+(\d|X)$/}]}
          >
            <Input
              disabled={legalAgentIsLegal || formDisabled}
              maxLength={18} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="证件开始时间"
            name={['legal_person_agent_cfg', 'legal_person_agent_identity_start_time']}
            rules={[{required: true,  message: '请选择'}]}
          >
            <SPDatePickerString
              disabled={legalAgentIsLegal || formDisabled}
              placeholder='请选择' format="YYYY-MM-DD"   />
          </Form.Item>
          <Form.Item
            label="证件结束时间"
            name={['legal_person_agent_cfg', 'legal_person_agent_identity_expire_time']}
            rules={[{required: true, message: '请选择' }]}
          >
            <SPDatePickerString
              disabled={legalAgentIsLegal || formDisabled}
              placeholder='请选择'  allowPermanent={true} format="YYYY-MM-DD"  />
          </Form.Item>

          <Form.Item
            label="签约手机号"
            name={['legal_person_agent_cfg', 'legal_person_agent_cell_phone_encrypt']}
            rules={[{ required: true, message: '请输入正确的手机号',pattern: /^\d{11}$/}]}>

            <Input maxLength={11} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="签约邮箱"
            name={['legal_person_agent_cfg', 'legal_person_agent_email']}
            rules={[{required: true, message: '请输入正确的邮箱', pattern: /^[a-zA-Z0-9+_.]+@[a-zA-Z0-9_.]+$/}]}
          >
            <Input maxLength={30} placeholder='请输入'></Input>
          </Form.Item>
        </div>
      </Card>
      <Card title='开户意愿信息'>
        <div style={{width: '50%', margin: '0 auto'}}>
          <Form.Item
            label="开户意愿书照片"
            extra={(<div style={{color: '#ff4d4f'}}>意愿书签字人必须为法人</div>)}
            name={['intent_letter_cfg', 'intent_letter_url']}
            rules={[{required: true, message: '请上传'}]}
          >
            <div
              onClick={downLoadTemplate}
              style={{display: 'flex', alignItems: 'center', color: '#F27935', fontSize: '16px', marginBottom: '16px', marginTop: '6px'}}>
              <DownloadOutlined style={{marginRight: '4px'}} />
              模版下载
            </div>
            <Form.Item
              noStyle
              name={['intent_letter_cfg', 'intent_letter_url']}
            >
              <SPUploadSinglePhoto  fileSize={10} action={COMMON_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
            </Form.Item>
          </Form.Item>
          <Form.Item
            label="开户意愿书人物照"
            extra={(<div style={{color: '#ff4d4f'}}>手持意愿书拍照人必须为法人</div>)}
            name={['intent_letter_cfg', 'intent_letter_sign_person_url']}
            rules={[{required: true, message: '请上传'}]}
          >
            <div style={{width: '250px', display: 'flex'}}>
              <Form.Item
                name={['intent_letter_cfg', 'intent_letter_sign_person_url']}
                noStyle
              >
                <SPUploadSinglePhoto
                  fileSize={10}
                  action={COMMON_URL}
                  hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
              </Form.Item>
              <div style={{position: 'relative'}}>
                <SPUploadSinglePhoto isDisabled
                                     value='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/shiliyiyuanhezhao.png'
                                     action={ID_CARD_URL} hideTitle uploadBtnText='上传图片'></SPUploadSinglePhoto>
                <div style={{bottom: '-20px', textAlign: 'center'}}>示例图</div>
              </div>
            </div>
          </Form.Item>
        </div>
      </Card>
      <Card title='企业账户信息'>
        <div style={{width: '50%', margin: '0 auto'}}>
          <Form.Item
            label="账户类型"
            name={['merchant_bank_cfg', 'merchant_bank_account_type']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPSelectWithEnum
              placeholder='请选择'
              enums={enums}
              enumKey={'merchant_bank_account_type'}>
            </SPSelectWithEnum>
          </Form.Item>
          <Form.Item
            label="账户名称"
            name={['merchant_bank_cfg', 'name']}
            rules={[
              {required: true, message: '请输入'},
            ]}
          >
            <Input disabled placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="银行账号"
            name={['merchant_bank_cfg', 'account_no']}
            rules={[
              {required: true, message: '请输入'},
              { pattern: /^[\d]+$/, message: '请输入数字'},
            ]}
          >
            <Input style={{width: '100%'}} maxLength={50} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="开户银行"
            name={['merchant_bank_cfg', 'bank_name']}
            rules={[{required: true, message: '请选择'}]}
          >

            <SPSelectWithApi
              showSearch
              params={{
                bank_name: defaultBankQueryStr
              }}
              filterOption={(input:any, option: any) => (option?.label ?? '').includes(input)}
              onChange={onBankChange}
              method={'get'}
              resListPath='data'
              labelKey='bankName'
              valueKey='bankName'
              placeholder="请选择"
              url={_APIS.SUPPLIER_ENTRY.BANK_LIST}
            ></SPSelectWithApi>
          </Form.Item>
          <Form.Item
            label='开户支行'
            style={{marginTop:'20px'}}
            name={['merchant_bank_cfg', 'branch_bank']}
            rules={[{required: true, message: '请输入'}]}
          >
            <Input maxLength={50} placeholder='请输入'></Input>
          </Form.Item>
          <Form.Item
            label="开户行省市"
            name={['merchant_bank_cfg', 'city_id']}
            rules={[{required: true, message: '请选择'}]}
          >
            <SPAggregate noStyle names={[['merchant_bank_cfg', 'province_id'], ['merchant_bank_cfg', 'city_id']]}>
              <Cascader
                multiple={false}
                placeholder='请选择'
                displayRender={displayRender}
                fieldNames={{ label: 'name', value: 'didi_id', children: 'child' }}
                style={{ width: '100%' }}
                options={cityListOrigin}
              />
            </SPAggregate>
          </Form.Item>
        </div>
      </Card>
      <Form disabled={false}>
        <Form.Item>
          <div style={{
            width: '50%',
            height: '100px',
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {
              <>
                <Button disabled={![0, 2].includes(supplierInfo?.entering_status)} onClick={onSubmit} type='primary'> 提交审核 </Button>
                <Button disabled={![0, 2].includes(supplierInfo?.entering_status)} onClick={onSave} type='default' style={{marginLeft: '20px'}}> 保存信息 </Button>
              </>
            }

            {
              <Button style={{marginLeft: "20px"}} disabled={![3, 4, 5].includes(supplierInfo?.entering_status)} onClick={() => nextStep(1)} type='primary'> 下一步 </Button>
            }
          </div>
        </Form.Item>
      </Form>


    </Form>
  )
}

export default SPApplySettlementAccount
